var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 17.333V9.83301V17.333ZM9.50002 17.333L7.41669 15.6663L9.50002 17.333ZM9.50002 17.333L11.5834 15.6663L9.50002 17.333Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 17.333L11.5834 15.6663M9.50002 17.333V9.83301V17.333ZM9.50002 17.333L7.41669 15.6663L9.50002 17.333Z",
    stroke: "#CA001B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69501 6.59766C2.90685 6.79598 2.21824 7.27529 1.75855 7.94552C1.29887 8.61576 1.09974 9.43079 1.1986 10.2375C1.29745 11.0442 1.68748 11.787 2.2954 12.3264C2.90332 12.8658 3.68728 13.1647 4.50001 13.1668H5.33334",
    stroke: "#CA001B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6917 4.94842C12.4069 3.82057 11.7038 2.84321 10.7251 2.21447C9.74642 1.58574 8.56525 1.35267 7.42107 1.56251C6.27689 1.77235 5.2553 2.40941 4.56341 3.34454C3.87151 4.27967 3.56107 5.4429 3.69502 6.59842C3.69502 6.59842 3.82252 7.33342 4.08335 7.75009",
    stroke: "#CA001B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 13.1663C14.255 13.1659 14.8367 13.0409 15.3732 12.7996C15.9098 12.5582 16.3892 12.2059 16.7798 11.7659C17.1704 11.3259 17.4634 10.8082 17.6395 10.2468C17.8156 9.68539 17.8708 9.09306 17.8015 8.5088C17.7322 7.92453 17.5399 7.36156 17.2373 6.85696C16.9348 6.35235 16.5288 5.91755 16.046 5.58116C15.5633 5.24478 15.0148 5.01444 14.4367 4.90531C13.8585 4.79618 13.2638 4.81073 12.6917 4.94801L11.5833 5.24967",
    stroke: "#CA001B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.204a976d7ab0a20435f2acc1da8d6249.svg";
export { ForwardRef as ReactComponent };